import React from "react";
import "../../SpearParts/Layouts/Layouts.css";

export const NewAbout = () => {
  return (
    <>
      <section id="sec-why  ">
        <div className="container brand-cont">
          <div className="row ">
            <div className="col-lg-6 offset-lg-3">
              <h2 className="text-center Layout-Title">WHY ASIA PART SOUQ</h2>
              <p className="text-center mb-5">
                We offer a vast and comprehensive catalogue of genuine and
                high-quality aftermarket spare parts. Our partnerships with
                leading global brands mean you can trust that every part you
                purchase is authentic and reliable.
              </p>
            </div>
          </div>
          <div className="row About-row">
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why1.svg"} />
                <h6 className="About-h6">Original Products</h6>
                <p>
                  When it comes to vehicle maintenance and repair, the quality
                  of a part is everything. Our Original Products guarantee that
                  you are purchasing parts that are manufactured to the exact
                  specifications and quality standards of the original equipment
                  manufacturer (OEM)
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why2.svg"} />
                <h6 className="About-h6">Affordable Rates</h6>
                <p className="About-p">
                  Obtaining high-quality, genuine parts shouldn't break the
                  bank. At Asia Part Souq, we leverage our strong relationships
                  with manufacturers and suppliers to secure the best possible
                  pricing.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="why-div">
                <img src={"images/why3.svg"} />
                <h6 className="About-h6">Wide variety</h6>
                <p className="About-p">
                  Our website is designed with you in mind. With intuitive
                  search functionality, detailed product information, and a
                  secure checkout process, finding and buying the right parts
                  has never been easier. We've optimized every step to save you
                  time and provide complete confidence in your purchase.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="d-flex justify-content-center align-items-center">
        <section id="sec-blog" style={{ marginTop: "-50px" }}>
          <div className="container">
            <h2 className="mb-md-5 Layout-Title NewsTitle">NEWS & EVENTS</h2>
            <div className="row">
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src={"images/Engineering/ENG-BLOG1.jpg"} />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    Beyond the Blueprint: The Age of Intelligent Engineering
                    Parts
                  </h6>
                  <p className="About-p">
                    This article explores the growing trend of integrating
                    sensors and micro-electronics directly into mechanical and
                    industrial components. It will explain how these "smart"
                    parts are transforming traditional maintenance from a
                    reactive process to a predictive one.
                  </p>
                  {/* <button className="read-more-btn">Read More</button> */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src={"images/Engineering/ENG-BLOG2.jpg"} />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    3D Printing's Next Chapter: On-Demand Engineering Parts
                  </h6>
                  <p className="About-p">
                    This blog post will demystify the use of 3D printing, or
                    additive manufacturing, for creating final-use engineering
                    parts, not just prototypes. It will highlight how this
                    technology is changing the global supply chain, making it
                    more agile and sustainable.
                  </p>
                  {/* <button className="read-more-btn">Read More</button> */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="blog-div">
                  <div className="blog-img">
                    <img src={"images/Engineering/eng-blog3.png"} />
                    <span className="date">Sep 21, 2022</span>
                  </div>
                  <h6 className="About-h6">
                    Greener Gears: Pioneering a Sustainable Future with Recycled
                    and Bio-Based Materials
                  </h6>
                  <p className="About-p">
                    his article will focus on the latest developments in
                    sustainable engineering materials. It will discuss how the
                    industry is moving away from a linear "make-use-dispose"
                    model and embracing a circular economy.
                  </p>
                  {/* <button className="read-more-btn">Read More</button> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
